<template>
  <div class="layout">
    <h1>台灣樂團專題｜時代的聲音！一窺台灣樂團歷史與獨立音樂發展</h1>
    <div class="out">
      <picture>
        <source media="(min-width:900px)" srcset="../assets/Banner.png">
        <source media="(min-width:550px)" srcset="../assets/Banner2.png">
        <img src="../assets/Banner3.png" alt="Banner">
      </picture>
      <p class="bannertext pc">
        從LiveHouse傳來的樂團演奏聲蘊藏著台灣無窮的創作力，<br>
        代表我們這塊島嶼的世代之聲，究竟是什麼呢？<br>
        民視新聞網特別邀請多組獨立樂團與金曲歌王，帶領大家一窺台灣樂團各種歷史大事件，從幕前到幕後，揭密豐富的LiveHouse文化，紀錄創作者的音樂軌跡。
      </p>

    </div>
    <p class="bannertext1 mb">
      從LiveHouse傳來的樂團演奏聲蘊藏著台灣無窮的創作力，
      代表我們這塊島嶼的世代之聲，究竟是什麼呢？<br>
      民視新聞網特別邀請多組獨立樂團與金曲歌王，帶領大家一窺台灣樂團各種歷史大事件，從幕前到幕後，揭密豐富的LiveHouse文化，紀錄創作者的音樂軌跡。
    </p>
  </div>
</template>

<script>
/*eslint-disable*/
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }, methods: {
    increment() {
      alert('ddd')
    }
  },
}


</script>


<style scoped>
h1 {
  position: absolute;
  top: -10rem;
}

.layout {
  margin: 1rem auto;
  margin-top: 0.5rem;
  margin-bottom: -8.5rem;
}


.bannertext {
  color: white;
  position: relative;
  top: -11rem;
  left: 0rem;
  margin-left: 2rem;
  letter-spacing: .3rem;
  max-width: 900px;
}

@media screen and (max-width:900px) {

  .bannertext {
    color: white;
    position: relative;
    top: -13rem;
    width: 100%;
    left: 0rem;
    padding: 1rem;
    letter-spacing: .3rem;
    margin: auto;
    max-width: 700px;
  }

  .layout {
    margin-top: 1rem;
    margin-bottom: -10rem;
  }

  .out {
    margin: 1rem
  }
}


@media screen and (max-width:768px) {

  .bannertext1 {
    position: relative;
    top: -11rem;
    color: white;
    margin: 1rem;
    padding: 0 1rem;
    text-align: justify;
  }

  .layout {
    margin-top: 1rem;
    margin-bottom: -8rem;
    margin-bottom: -6.5rem;
  }

  img {
    width: 100%;
    border-radius: 30px;
  }
}

@media screen and (max-width:680px) {


  .layout {
    margin-top: -.5rem;
    margin-bottom: -7.5rem;

  }
}



@media screen and (max-width:500px) {

  .bannertext1 {
    position: relative;
    top: -14.5rem;
    color: white;
    margin: 1rem;
    padding: 0 1.5rem;
  }

  .layout {
    margin-top: 0rem;
    margin-bottom: -8rem;
  }

  img {
    width: 100%;
    border-radius: 30px;
  }
}



@media screen and (max-width:480px) {
  .bannertext1 {
    position: relative;
    top: -14.5rem;
    color: white;
    margin: 1rem;
    padding: 0 1.2rem;
  }

  .layout {

    margin-bottom: -11rem;
  }


}


@media screen and (max-width:400px) {
  .bannertext1 {
    position: relative;
    top: -15rem;
    color: white;
    margin: 1rem;
    padding: 0 1.2rem;
  }

  .layout {
    margin-bottom: -12rem;

  }


}


@media screen and (max-width:380px) {
  .bannertext1 {
    position: relative;
    top: -15rem;
    color: white;
    margin: 1rem;
    padding: 0 1.2rem;
  }

  .layout {
    margin-bottom: -12.5rem;
  }


}

img {
  width: 100%;
}
</style>
